module.exports = __webpack_public_path__ + "img/category-new-released.69daae1a.png";